import Vue from 'vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import only what is needed for significant bundle size reduction.
import {
  LayoutPlugin,
  ImagePlugin,
  ButtonPlugin,
  SpinnerPlugin,
  FormPlugin,
  FormSelectPlugin,
  FormGroupPlugin,
  FormInputPlugin,
} from "bootstrap-vue";

Vue.use(ImagePlugin);
Vue.use(ButtonPlugin);
Vue.use(LayoutPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);

